import { render } from "./leaves-employee-modal.vue?vue&type=template&id=74357960"
import script from "./leaves-employee-modal.vue?vue&type=script&lang=js"
export * from "./leaves-employee-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__